module.exports = __webpack_public_path__ + "static/derjenige-der-nicht-weiß-zu-lieben-kampft-04-4fdc393da4f2ca4a9a802c84cc72a654.jpg";